import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const PlanxAPi = createApi({
  reducerPath: "PlanxAPi",
  baseQuery: authBaseQuery,
  endpoints: (builder) => ({
    getPlanXNotes: builder.query({
      query: () => ({
        url: `v1/planxnote`,
        method: "GET",
      }),
    }),

    addPlanXNote: builder.mutation({
      query: (payload) => ({
        url: `v1/planxnote`,
        method: "POST",
        body: payload,
        // headers: {
        //   "Content-Type": "application/json",
        // },
      }),
    }),
    updatePlanXNote: builder.mutation({
      query: (payload) => ({
        url: `v1/planxnote`,
        method: "PUT",
        body: payload,
        // headers: {
        //   "Content-Type": "application/json",
        // },
      }),
    }),
    getPlanXLogs: builder.query({
      query: ({
        page = 1,
        limit = 10,
        search = "",
        startDate,
        endDate,
      } = {}) => {
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        if (limit) queryParams.push(`limit=${limit}`);
        if (search) queryParams.push(`plan_name=${encodeURIComponent(search)}`);
        if (!search) {
          if (startDate) queryParams.push(`startDate=${startDate}`);
          if (endDate) queryParams.push(`endDate=${endDate}`);
        }

        const queryString =
          queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

        return `v1/planxlogs${queryString}`;
      },
    }),

    updatePlanxNoteStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `v1/planxnote`,
        method: "PUT",
        body: { id, status },
        // headers: {
        //   "Content-Type": "application/json",
        // },
      }),
    }),
    deletePlanxNote: builder.mutation({
      query: (id) => ({
        url: `v1/planxnote/${id}`,
        method: "DELETE",
      }),
    }),

    submitPlanxForm: builder.mutation({
      query: ({ formData, isEdit }) => ({
        url: `v1/planxlogs`,
        method: isEdit ? "PUT" : "POST",
        body: formData,
        // headers: {
        //   Authorization: `Bearer ${token}`,
        // },
      }),
    }),

    getAllAccounts: builder.query({
      query: ({ page, limit, search} = {}) => {
        const queryParams = [];
    
        if (page) queryParams.push(`page=${page}`);
        if (limit) queryParams.push(`limit=${limit}`);
        if (search) queryParams.push(`search=${encodeURIComponent(search)}`); 
    
        const queryString =
          queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
    
        return `accounts/get_all_account_redis${queryString}`;
      },
    }),
    getPageDetailByPlanxId: builder.query({
      query: (id) => `v1/plan_page_details_with_planxid/${id}`,
    }),
    sendPlanDetails: builder.mutation({
      query: ({ id, updatedPlanDetails, planStatus }) => {
        const payload = {
          planx_id: id,
          plan_pages: updatedPlanDetails,
          plan_status:
            planStatus === "close" || planStatus === "open" ? "saved" : "",
        };

        return {
          url: `v1/add_multiple_plan_page_data_v2`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getPlanDetails: builder.query({
      query: (id) => `v1/planxlogs/${id}`,
    }),

    getPlanPagesVersionDetails: builder.query({
      query: (id) => {
        return `v1/get_plan_pages_version_details/${id}`
      },
    }),
    getPlanPagesByIdVersion: builder.query({
      query: ({ id, version }) => ({
        url: `v1/get_plan_pages_by_id_version`,
        method: "GET",
        params: {
          planx_id: id,
          version: version,
        },
      }),
    }),
    sendPlanxLogUpdate: builder.mutation({
      query: ({ endpoint, payload }) => ({
        url: endpoint,
        method: "PUT",
        body: payload,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
  }),
});

export const {
  useGetPlanXNotesQuery,
  useAddPlanXNoteMutation,
  useUpdatePlanXNoteMutation,
  useGetPlanXLogsQuery,
  useUpdatePlanxNoteStatusMutation,
  useDeletePlanxNoteMutation,
  useSubmitPlanxFormMutation,
  useGetAllAccountsQuery,
  useGetPageDetailByPlanxIdQuery,
  useSendPlanDetailsMutation,
  useGetPlanDetailsQuery,
  useGetPlanPagesVersionDetailsQuery,
  useGetPlanPagesByIdVersionQuery,
  useSendPlanxLogUpdateMutation,
} = PlanxAPi;

export default PlanxAPi;
